module.exports = __webpack_public_path__ + "static/img/product03-6.b98b1945.png";